import * as React from 'react';
import dashboardImage from '../../Mri.Web.Common/Assets/dashboard.png';
import laptopListImage from '../../Mri.Web.Common/Assets/laptop-list.png';
import boldvuIcon from '../../Mri.Web.Common/Assets/boldvu.png';
import statsImage from '../../Mri.Web.Common/Assets/stats.png';
import ticketImage from '../../Mri.Web.Common/Assets/ticket.png';
import popVuLaptop from '../../Mri.Web.Common/Assets/popvu-laptop.png';

/**
 * Landing.tsx needs to be kept a super simple
 * basic React function that renders natively
 * in Internet explorer. Only import React.
 * No new ES6+ features
 */
export function Landing() {
    return (
        <div id="home">
            <div className="home-background">
                <div className="home-header p-relative w-100">
                    <div className="fade h-100 w-100" />
                    <img className="mri-logo p-4" src={boldvuIcon} />
                    <div className="h-100 w-100 d-table header-text">
                        <div className="align-middle px-2 d-table-cell text-center">
                            <div className="header-title">
                                SmartVu
                                <span className="header-registered">&reg;</span>
                            </div>
                            <h2 className="subtitle">Advanced Monitoring Portal</h2>

                            <a href="/account/spa-login" className="btn btn-lg btn-primary mt-5">
                                Enter Portal
                            </a>
                        </div>
                    </div>
                </div>

                <div className="row features pb-5 features-1">
                    <div className="col-12 header-padding">
                        <h2 className="text-center mb-5">Features</h2>
                    </div>

                    <div className="col-12 vh-50 fade-content">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-teal text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 mb-5 padding-mobile-2 p-5">
                                            <img src={dashboardImage} className="img-fluid" />
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="h-100 d-table w-100">
                                                <div className="text-center p-3 p-lg-5 d-table-cell align-middle">
                                                    <h2 className="card-title">Display Dashboard</h2>
                                                    <h6 className="card-text">
                                                        Monitor display events and stay informed with updated
                                                        notifications and system alerts from your displays.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 feature-seperator">
                        <hr />
                    </div>

                    <div className="col-12 fade-content vh-50">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-teal text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 d-lg-none d-block padding-mobile-2 mb-5 p-5">
                                            <img src={statsImage} className="img-fluid home-images" />
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="h-100 d-table w-100">
                                                <div className="text-center p-3 p-lg-5 d-table-cell align-middle">
                                                    <h2 className="card-title">Monitor Statistics</h2>
                                                    <h6 className="card-text">
                                                        Monitor your displays' connection status, brightness settings,
                                                        temperatures, fan speeds, and more.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 d-lg-block d-none mb-5 p-5">
                                            <img src={statsImage} className="img-fluid home-images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 feature-seperator">
                        <hr />
                    </div>

                    <div className="col-12 fade-content vh-50">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-teal text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 mb-5 padding-mobile-2 p-5">
                                            <img src={laptopListImage} className="img-fluid home-images" />
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="h-100 d-table w-100">
                                                <div className="text-center p-3 p-lg-5 d-table-cell align-middle">
                                                    <h2 className="card-title">Search Displays</h2>
                                                    <h6 className="card-text">
                                                        "View Displays" - a streamlined overview of your display network
                                                        with dynamic filtering.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 feature-seperator">
                        <hr />
                    </div>

                    <div className="col-12 fade-content vh-50">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-teal text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-12 image-column-mobile mb-3 padding-mobile-2 p-5">
                                            <img src={ticketImage} className="img-fluid home-images" />
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="h-100 d-table w-100">
                                                <div className="text-center p-3 p-lg-5 d-table-cell align-middle">
                                                    <h2 className="card-title">Submit Tickets</h2>
                                                    <h6 className="card-text">
                                                        Submit support tickets and engage NOC engineers to help resolve
                                                        display issues.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-6 image-column mb-5 padding-mobile-2 p-5">
                                            <img src={ticketImage} className="img-fluid home-images" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 feature-seperator">
                        <hr />
                    </div>

                    <div className="col-12 fade-content vh-50">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-teal text-center">
                                    <div className="row justify-content-center">
                                        <div className="col-lg-6 mb-5 padding-mobile-2 p-5">
                                            <img src={popVuLaptop} className="img-fluid home-images" />
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="h-100 d-table w-100">
                                                <div className="text-center p-3 p-lg-5 d-table-cell align-middle">
                                                    <h2 className="card-title">PopVu™</h2>
                                                    <h6 className="card-text">
                                                        Get an inside look at what is being shown on your display, in
                                                        real time, with PopVu™.
                                                    </h6>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-12 parallax">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle">
                                    <div className="w-lg-50 d-inline-block">
                                        <h1>An Inside Look at Smart-Vu</h1>

                                        <p className="card-text">
                                            SmartVu® is an excellent tool at helping customers monitor and keep track of
                                            their displays without having to discover discrepencies in the field. Find
                                            it first on SmartVu®!
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row features">
                    <div className="col-lg-6">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-center p-5">
                                    <h1>Interested in MRI?</h1>

                                    <p className="card-text">
                                        Check out the website to see a variety of other features and products from MRI.
                                    </p>

                                    <a className="btn btn-outline-primary" href="https://lg-mri.com/">
                                        VISIT MRI
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 feature-seperator d-xl-none d-lg-none">
                        <hr />
                    </div>

                    <div className="col-lg-6">
                        <div className="d-table h-100 w-100">
                            <div className="d-table-row">
                                <div className="d-table-cell align-middle text-center p-5">
                                    <h1>MRI Partners</h1>

                                    <p className="card-text">
                                        Join the MRI Partner Program and receive exclusive access to our enterprise
                                        sales support team and tools.
                                    </p>

                                    <a
                                        className="btn btn-outline-primary"
                                        href="https://lg-mri.com/contact/become-a-partner/"
                                    >
                                        BECOME A PARTNER
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 footer text-center">
                        Copyright &copy; 2018 MRI &nbsp; | &nbsp; SmartVu® &nbsp; | &nbsp;
                        <a href="https://lg-mri.com/privacy-statement/">Privacy Statement</a>
                    </div>
                </div>
            </div>
        </div>
    );
}
